import { Control } from "react-hook-form";
import SelectComponent from "@via/components/select/select";
import {
  FieldTypeEnum,
  OperatorOption,
} from "@via/components/advanced-filter/helpers/types";
import { getOperatorsForFieldType } from "@via/components/advanced-filter/helpers/utils";

interface OperatorSelectProps {
  control: Control<any>;
  name: string;
  fieldType: FieldTypeEnum;
  placeholder?: string;
  enableClear?: boolean;
  disabled?: boolean;
}

export default function OperatorSelect({
  control,
  name,
  fieldType,
  placeholder = "Select operator...",
  enableClear = false,
  disabled = false,
}: OperatorSelectProps) {
  // Get operators based on field type
  const operatorOptions: OperatorOption[] = getOperatorsForFieldType(fieldType);

  return (
    <SelectComponent
      control={control}
      name={name}
      options={operatorOptions}
      placeholder={placeholder}
      enableClear={enableClear}
      readOnly={disabled}
    />
  );
}
